exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".time-zone-wrapper {\n  text-align: center;\n  min-width: 150px;\n}\n", ""]);
